import { Link } from "react-router-dom";
import { Layout } from "../components/layout/Layout";
import { SEO } from "../components/seo/SEO";
import { site } from "../data/site";

export function NotFound() {
  return (
    <Layout>
      <SEO
        title={`Page Not Found - ${site.name}`}
        description="The requested yawiki.org page could not be found."
        canonical={`${site.url}/404`}
      />
      <section className="not-found">
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p>The page may have moved, or it may be a future-dated article that is not public yet.</p>
        <Link className="button-link" to="/">
          Return to main page
        </Link>
      </section>
    </Layout>
  );
}
